(function () {
    'use strict';
    var m = angular.module('dashboard');
    m.factory('userTopCollaboratorsPlotLogic', ["userDao", "widgetPolling", "verticalPlotLogicCore", "widgetSettings", "$q", function (userDao, widgetPolling, verticalPlotLogicCore, widgetSettings, $q) {
        return function ($scope, logic) {
            var id = widgetPolling.scope().id;
            var destroyPlot = _.noop;
            function loadData() {
                destroyPlot();
                destroyPlot = verticalPlotLogicCore($scope, logic, {
                    retrieve: function () {
                        return userDao.topUserCollaborators(id, !logic.showExternal, !logic.showInternal).pagination(0, logic.lines).order('count', 'desc');
                    },
                    idColumn: 'entity_id',
                    makeLabel: function (row) {
                        var counter = ' <span class="counter">' + row.count + '</span>';
                        return row.display_name + (window.guiVersion === 2 ? counter : '');
                    },
                    linkTo: 'user'
                });
            }
            var paramsWatch = $scope.$watch(function () {
                return widgetSettings.params($scope.model.uuid);
            }, function (params) {
                loadData();
            }, true);
            return function () {
                paramsWatch();
                destroyPlot();
            };
        };
    }]);
}());